import { DecimationPolicy, TimeseriesFetchSlot, TimeseriesTimeRange } from "./types";

/**
 * Serialize the time range to a string.
 * 
 * Used to build the request key.
 */
function serializeTimeRange(timeRange: TimeseriesTimeRange): string {
  if ('start' in timeRange && 'end' in timeRange) {
    return `${timeRange.start}|${timeRange.end}`;
  }

  return JSON.stringify(timeRange);
}

/**
 * Build the request key.
 * 
 * Used to identify the request in the data transport.
 */
export function buildRequestKey(
  slot: TimeseriesFetchSlot,
  timeRange: TimeseriesTimeRange,
  decimation?: DecimationPolicy
): string {
  const decimationPart = decimation
    ? decimation.enabled
      ? `dec:${decimation.points}`
      : 'dec:none'
    : 'dec:default';

  return `${slot}:${serializeTimeRange(timeRange)}:${decimationPart}`;
}